module.exports = __webpack_public_path__ + "img/BackgroundRemoval01.f8aae6c4.png";